import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "./NavBar";
import { AuthContext } from "./AuthContext";

export const VoteFansThankYou = () => {

    const navigate = useNavigate()

    const { signOut } = useContext(AuthContext)

    useEffect(() => {

        // Set default back navigation to home page
        const handlePopState = (event) => {
            event.preventDefault();
            navigate("/", { replace: true });
        }

        window.addEventListener("popstate", handlePopState)

        return () => {window.removeEventListener("popstate", handlePopState)}

    }, [navigate])

    return(

        <div className="main-container">

            <Navbar text1="Zsűri Bejelentkezés" text2="Kijelentkezés" onClick1={() => navigate("/login-judge")} onClick2={signOut} second/>

            <div className="item-container">
                <p>Köszönjük, hogy szavazott!</p>
                <button className="go-back-button" onClick={() => navigate('/vote-fans', {state: {cameFrom: "thx"}, replace: true})}>Szavazat Megváltoztatása</button>
            </div>

        </div>

    )

}